module.exports = __webpack_public_path__ + "media/6.9d9a9067.mp3";